<h1 mat-dialog-title>Cost Center Lookup</h1>

<mat-dialog-content class="!pb-0">
  <div class="flex flex-col items-center">
    <mat-form-field class="w-80">
      <mat-label>Cost Center Name or Number</mat-label>
      <input matInput [formControl]="filter" />
    </mat-form-field>
  </div>

  <hr class="border-[lightgray]" />

  <div class="cost-centers-list flex w-full flex-col items-center gap-4 p-4">
    @for (cc of filteredCostCenters; track cc) {
      <button
        mat-raised-button
        class="!h-auto !w-2/3 !min-w-[20rem] !max-w-[45rem] !justify-start"
        notranslate
        (click)="handleSelection(cc)"
      >
        <div class="flex flex-wrap text-left">
          <span class="w-full text-base">{{ cc.Description }}</span>
          <span class="w-full text-sm text-gray-500">{{ cc.CostCtr | zeroTrim }}</span>
        </div>
      </button>
    }

    @if (filteredCostCenters.length === 0) {
      <h4>
        No cost centers match "<em>{{ filter.getRawValue() }}</em
        >"
      </h4>
    }
  </div>
</mat-dialog-content>

<!-- Put the close X button last so that it isn't auto-focused when the modal is opened -->
<button mat-icon-button mat-dialog-close aria-label="Close"><mat-icon>close</mat-icon></button>
